'use client'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { useRouter } from '@/i18n/navigation'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { Campaign } from '@/types/campaign'
import { Calendar } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { useEffect } from 'react'

interface CampaignCardProps {
  campaign: Campaign
  isRegistered?: boolean
  onRegisterClick: (campaign: Campaign) => void
}

export const CampaignCard = ({
  campaign,
  isRegistered,
  onRegisterClick,
}: CampaignCardProps) => {
  const t = useTranslations('community_threads.campaign.list')
  const router = useRouter()

  // Prefetch sẵn route quản lý đăng ký - nếu không, router.push() phải chờ
  // fetch RSC payload lúc click mới điều hướng, gây cảm giác delay.
  useEffect(() => {
    if (isRegistered) {
      router.prefetch('/account/friends-of-coolmate')
    }
  }, [isRegistered, router])

  const handleClick = () => {
    if (isRegistered) {
      router.push('/account/friends-of-coolmate')
      return
    }
    onRegisterClick(campaign)
  }

  return (
    <div
      className='group relative aspect-[3/4] w-full cursor-pointer overflow-hidden rounded-2xl bg-gray-200'
      onClick={handleClick}
    >
      <Badge
        variant={campaign.statusVariant ?? 'secondary'}
        className='absolute left-4 top-4 z-10 rounded-full px-3 py-1 text-xs font-bold'
      >
        {campaign.statusLabel}
      </Badge>

      <Image
        src={ImageHelper.getN7ImageUrl(campaign.banner)}
        alt={campaign.title}
        width={500}
        height={667}
        className='absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105'
      />

      <div className='absolute inset-x-0 bottom-0 flex flex-col gap-3 bg-gradient-to-t from-black via-black/80 to-transparent p-4 pt-20'>
        <h4 className='font-criteria text-lg font-bold leading-tight text-white'>
          {campaign.title}
        </h4>

        <div className='space-y-1.5 text-xs text-white/80'>
          <div className='flex items-start gap-1.5'>
            <Calendar size={14} className='mt-0.5 shrink-0' />
            <span>
              {t('register_time', {
                start: campaign.registerStart,
                end: campaign.registerEnd,
              })}
            </span>
          </div>
          {/* <div className='flex items-start gap-1.5'>
            <Gift size={14} className='mt-0.5 shrink-0' />
            <span>{t('gift', { gift: campaign.gift })}</span>
          </div> */}
        </div>

        <Button variant='white' className='w-full'>
          {isRegistered ? t('manage_registration') : t('register_now')}
        </Button>
      </div>
    </div>
  )
}
